// Slideshow for Main Product Image
document.addEventListener("DOMContentLoaded", () => {
  const mainProductPage = document.querySelector('#MainProductPage[data-page="main-product"]');

  if (mainProductPage) {
    console.log("Initializing slideshow on main product page...");
    const slideshowContainer = document.getElementById("product-slideshow");
    const slides = slideshowContainer.querySelectorAll(".slideshow-image");
    let currentSlide = 0;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.style.display = i === index ? "block" : "none";
      });
    }

    function nextSlide() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }

    // Initialize slideshow
    showSlide(currentSlide);
    setInterval(nextSlide, 3000); // Change slides every 3 seconds
  } else {
    console.log("Main product page not detected.");
  }
});



if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
  const necklaceImage = document.getElementById("necklace-slideshow");

  const images = [
    "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/silver-necklace.png?v=1756519029",
    "https://cdn.shopify.com/s/files/1/0699/1419/8173/files/gold-custom-necklace-2.png?v=1756514253"
  ];

  let currentIndex = 0;

  function changeImage() {
    currentIndex = (currentIndex + 1) % images.length; // Loop through images
    necklaceImage.src = images[currentIndex];
  }

  setInterval(changeImage, 2000); // Change image every 2 seconds
});



// Charm Filter Logic
document.addEventListener('DOMContentLoaded', function () {
  // Get the charm color selector buttons
  const colorButtons = document.querySelectorAll('.necklace-color-selector button');
  const charmOptions = document.querySelectorAll('.charm-option');

  // Add event listeners to each button
  colorButtons.forEach((button) => {
    button.addEventListener('click', function () {
      // Remove 'active' class from all buttons
      colorButtons.forEach((btn) => btn.classList.remove('active'));

      // Add 'active' class to the clicked button
      this.classList.add('active');

      // Get the selected color from the button's dataset
      const selectedColor = this.dataset.color;

      // Show/hide charms based on selected color
      charmOptions.forEach((option) => {
        if (selectedColor === 'all' || option.dataset.color === selectedColor) {
          option.style.display = 'block'; // Show matching charms
        } else {
          option.style.display = 'none'; // Hide non-matching charms
        }
      });
    });
  });
});

document.querySelector('.add-to-arrange-button').addEventListener('click', () => {
  const selectedCharms = [];
  
  // Loop through all charm options and check if the checkbox is selected
  document.querySelectorAll('.charm-option input[type="checkbox"]:checked').forEach((checkbox) => {
    const charmElement = checkbox.closest('.charm-option'); 
    const charmData = {
      id: charmElement.dataset.id, 
      image: charmElement.querySelector('img').src, // 
      name: charmElement.querySelector('.charm-option-name').textContent.trim(), // Get the charm name
    };
    selectedCharms.push(charmData);
  });

  // Debugging: Log the selected charms array to check if charms are being collected correctly
  console.log('Selected Charms:', selectedCharms);

  // Save the selected charms to localStorage
  try {
    localStorage.setItem('selectedCharms', JSON.stringify(selectedCharms));
    console.log('Charms saved to localStorage');
  } catch (e) {
    console.error('Error saving to localStorage:', e);
  }

  // Navigate to the Arrange Charms page
  try {
    window.location.href = '/pages/arrange-charms'; // Adjust this URL if needed
    console.log('Navigating to Arrange Charms page');
  } catch (e) {
    console.error('Error during navigation:', e);
  }
});

